import angular from 'angular';

const kformMinDirective = /* @ngInject */ () => ({
	restrict: 'A',
	require: 'ngModel',
	link: (
		/** @type {any} */ scope,
		/** @type {any} */ element,
		/** @type {any} */ attributes,
		/** @type {any} */ ctrl,
	) => {
		/** @type {number | undefined} */
		let minValue;
		ctrl.$validators.min = (/** @type {string} */ value) => {
			if (ctrl.$isEmpty(value) || angular.isUndefined(minValue)) {
				return true;
			}

			const valueAsNumber = angular.isNumber(value) ? value : Number.parseFloat(value);
			return minValue === undefined ? true : (valueAsNumber >= minValue);
		};

		scope.$watch(attributes.kformMin, (/** @type {any} */ value) => {
			if (angular.isDefined(value) && !angular.isNumber(value)) {
				// eslint-disable-next-line no-param-reassign
				value = Number.parseFloat(value);
			}
			minValue = angular.isNumber(value) && !Number.isNaN(value) ? value : undefined;
			ctrl.$validate();
		});
	},
});

export default kformMinDirective;
